"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.syncStaffWithActiveDirectory = void 0;
const axios_1 = __importDefault(require("axios"));
async function syncStaffWithActiveDirectory() {
    return await (0, axios_1.default)({
        method: 'get',
        url: '/userProfiles-api/1/staff/sync'
    });
}
exports.syncStaffWithActiveDirectory = syncStaffWithActiveDirectory;
